import React, { useState } from "react";
import { Link } from "react-router-dom";
import { links } from "./ItemLink";

const NavbarLinks = () => {
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");

  return (
    <>
      {links.map((link, index) => (
        <div key={index}>
          <div className="px-2 text-left md:cursor-pointer group">
            {/* Main Menu Item */}
            <h1
              className="py-7 flex justify-between items-center md:pr-0 pr-5 group"
              onClick={() => {
                heading !== link.name ? setHeading(link.name) : setHeading("");
                setSubHeading("");
              }}
            >
              {link.name}
              {/* Mobile dropdown icon */}
              <span className="text-xl md:hidden inline">
                <ion-icon
                  name={`${
                    heading === link.name ? "chevron-up" : "chevron-down"
                  }`}
                ></ion-icon>
              </span>
              {/* Desktop dropdown arrow */}
              <span className="text-xl md:mt-1 md:ml-2 hidden md:block group-hover:rotate-180 transition-transform">
                <ion-icon name="chevron-down"></ion-icon>
              </span>
            </h1>

            {/* Dropdown for desktop */}
            {link.submenu && (
              <div>
                <div className="absolute top-20 hidden group-hover:md:block hover:md:block">
                  <div className="py-3">
                    <div className="w-4 h-4 left-3 absolute mt-1 bg-white rotate-45"></div>
                  </div>
                  <div className="bg-white p-5 grid grid-cols-3 gap-10">
                    {link.sublinks.map((mysublinks, subIndex) => (
                      <div key={subIndex}>
                        <h1 className="text-lg font-semibold">
                          {mysublinks.Head}
                        </h1>
                        <ul>
                          {mysublinks.sublink.map((slink, sublinkIndex) => (
                            <li
                              key={sublinkIndex}
                              className="text-sm text-gray-600 my-2.5"
                            >
                              <Link
                                to={slink.link}
                                className="hover:text-primary"
                              >
                                {slink.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Mobile submenu */}
          <div className={`${heading === link.name ? "md:hidden" : "hidden"}`}>
            {/* Mobile sublinks */}
            {link.sublinks.map((slinks, slinkIndex) => (
              <div key={slinkIndex}>
                <div>
                  <h1
                    onClick={() =>
                      subHeading !== slinks.Head
                        ? setSubHeading(slinks.Head)
                        : setSubHeading("")
                    }
                    className="py-4 pl-7 font-semibold flex justify-between items-center"
                  >
                    {slinks.Head}
                    {/* Mobile sublinks toggle icon */}
                    <span className="text-xl md:mt-1 md:ml-2 inline">
                      <ion-icon
                        name={`${
                          subHeading === slinks.Head
                            ? "chevron-up"
                            : "chevron-down"
                        }`}
                      ></ion-icon>
                    </span>
                  </h1>
                  <div
                    className={`${
                      subHeading === slinks.Head ? "md:hidden" : "hidden"
                    }`}
                  >
                    {slinks.sublink.map((slink, innerIndex) => (
                      <li key={innerIndex} className="py-3 pl-14">
                        <Link to={slink.link}>{slink.name}</Link>
                      </li>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default NavbarLinks;
